/* unplugin-vue-components disabled */import { render } from "./Home.vue?vue&type=template&id=727d50c4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=727d50c4&lang=scss"
import "./Home.vue?vue&type=style&index=1&id=727d50c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727d50c4"]])

export default __exports__